import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { Language } from '../../models/language';

@Component({
  selector: 'lh-language-select',
  templateUrl: './language-select.component.html',
  styleUrls: ['./language-select.component.css'],
})
export class LanguageSelectComponent {
  @Input('show')
  showLanguageFlyout = false;

  @Output('showChange')
  showLanguageFlyoutChange = new EventEmitter<boolean>();

  @Input()
  languages: Language[] | null = null;

  @Output()
  onLanguageChange = new EventEmitter<string>();

  @Input()
  activeLanguage: Language | null = null;

  constructor(private ref: ElementRef) {}

  // Handle click outside of flyout.
  @HostListener('document:click', ['$event'])
  clickOnOther(event: any) {
    if (!this.ref.nativeElement.contains(event.target)) {
      this.showLanguageFlyout = false;
    }
  }

  toggleLanguageFlyout() {
    this.showLanguageFlyout = !this.showLanguageFlyout;
    this.showLanguageFlyoutChange.emit(this.showLanguageFlyout);
  }

  selectLanguage(event: any): void {
    const value = event.detail.selected;
    this.onLanguageChange.emit(value);
    this.showLanguageFlyout = false;
    this.showLanguageFlyoutChange.emit(this.showLanguageFlyout);
  }
}
